var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopyIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1663 4.83333V1.5C13.1663 1.27899 13.0785 1.06703 12.9223 0.910746C12.766 0.754465 12.554 0.666668 12.333 0.666668H1.49967C1.27866 0.666668 1.0667 0.754465 0.910419 0.910746C0.754139 1.06703 0.666342 1.27899 0.666342 1.5V12.3333C0.666342 12.5543 0.754139 12.7663 0.910419 12.9226C1.0667 13.0789 1.27866 13.1667 1.49967 13.1667H4.83301V16.4942C4.83301 16.9575 5.20717 17.3333 5.67217 17.3333H16.4938C16.6041 17.3334 16.7132 17.3118 16.8151 17.2697C16.917 17.2275 17.0095 17.1657 17.0875 17.0878C17.1654 17.0098 17.2272 16.9173 17.2694 16.8154C17.3115 16.7136 17.3331 16.6044 17.333 16.4942L17.3305 5.6725C17.3305 5.20917 16.9563 4.83333 16.4913 4.83333H13.1663ZM11.4997 4.83333H5.67217C5.20884 4.83333 4.83301 5.2075 4.83301 5.6725V11.5H2.33301V2.33333H11.4997V4.83333Z",
    fill: "#B9B8C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon);
export default __webpack_public_path__ + "static/media/copy_icon.2cfab25d094d3cdb85314a812d809825.svg";
export { ForwardRef as ReactComponent };